import { Component, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-hppopup',
  templateUrl: './hppopup.component.html',
  styleUrls: ['./hppopup.component.scss']
})
export class HppopupComponent implements OnInit {
  @Output() closeButtonClicked = new EventEmitter<void>();
  constructor() { }
  hidemodal(){
    this.closeButtonClicked.emit();
  }
  ngOnInit() {
  }

}
